import { PencilIcon } from '@grupoboticario/flora-react-icons';
import {
  CardInfo,
  CardInfoFieldWrapper,
  CardInfoField,
} from '../../sharedStyles';

import { CardInfoTitleSummary, EditButton, CardInfoFields } from '../styles';

interface ICardSummary {
  editStep?: any;
  stateClaim: any;
}

export const Card06 = ({ editStep, stateClaim }: ICardSummary): JSX.Element => {
  return (
    <CardInfo>
      <CardInfoTitleSummary>
        Dados bancários{' '}
        <span className="label">
          Não implica em reconhecimento da cobertura
        </span>
        {editStep && (
          <EditButton
            size="small"
            has="iconLeft"
            icon={<PencilIcon />}
            onClick={() => editStep(3)}
          >
            Editar
          </EditButton>
        )}
      </CardInfoTitleSummary>
      <CardInfoFields>
        <CardInfoFieldWrapper>
          <CardInfoField flex={4}>
            <span>Banco:</span>
            <p>
              {`${stateClaim.step.step3?.bank?.data?.NumeroCodigo} - ${stateClaim.step.step3?.bank?.data?.NomeReduzido}`}
            </p>
          </CardInfoField>
          <CardInfoField flex={2}>
            <span>Agência:</span>
            <p>{stateClaim.step.step3?.agency || '-'}</p>
          </CardInfoField>
          <CardInfoField flex={3}>
            <span>Conta Corrente/Poupança:</span>
            <p>{stateClaim.step.step3?.account || '-'}</p>
          </CardInfoField>
        </CardInfoFieldWrapper>
      </CardInfoFields>
    </CardInfo>
  );
};
